<template>
  <article>
    <v-form v-model="valid" @submit.prevent="onSubmit" enctype="multipart/form-data">
      <v-card bg-variant="light" v-if="user">
        <v-card-title>Editing user profile</v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <!-- <v-col cols="3">
              <v-img contain :src="user.logo ? user.logo : '/images/blank.svg'" />
            </v-col> -->
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Username"
                    v-model="user.username"
                    :rules="rules.username"
                    hint="Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only."
                    persistent-hint
                  />
                </v-col>
                <v-col>
                  <v-text-field label="Email Address" v-model="user.email" :rules="rules.email" hint="" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="First Name" v-model="user.first_name" hint="" />
                </v-col>
                <v-col>
                  <v-text-field label="Last Name" v-model="user.last_name" hint="" />
                </v-col>
              </v-row>

              <!-- <v-file-input 
                label="Company logo"
                show-size
                hint="Attach an image file, such as JPG or PNG"
                accept="image/*" 
                v-model="file"
              /> -->
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn class="success" type="submit">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </article>
</template>

<!-- <template>
  
</template> -->

<script>
import Users from "@/api/users"
export default {
  name: "Account",
  data() {
    return {
      valid: false,
      user: null,
      file: null,
      rules: {
        username: [v => !!v || "Name is required"],
        email: [v => !!v || "Email is required"]
      }
    }
  },
  created() {
    Users.retrieve(this.user.id).then(response => {
      this.user = response.data
    })
  },
  methods: {
    onSubmit() {
      let formData = new FormData()
      Object.keys(this.user).forEach(key => formData.append(key, this.user[key]))
      if (this.file) formData.set("logo", this.file)
      else formData.delete("logo")

      Users.patch(this.user.id, formData).then(response => {
        this.notify(response.data)
        this.$router.push({ name: "home" })
      })
    }
  }
}
</script>
